/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { Observable} from 'rxjs';
import { MedicineApi } from '../api/medicine.api';
import { MedicineData, Medicine } from '../../../interfaces/masters/medicine';

@Injectable()
export class MedicineService extends MedicineData {

  constructor(private api: MedicineApi) {
    super();
  }
searchList(url: string,data:any): Observable<any> {
      return this.api.searchList(url,data);
    }

  list(url: string): Observable<Medicine[]> {
    return this.api.list(url);
  }

  medicinePresctiptionGet(url: string): Observable<any> {
    return this.api.medicinePresctiptionGet(url);
  }

  get_by_id(url: string): Observable<Medicine[]> {
    return this.api.get_by_id(url);
  }

  getById(url:string): Observable<Medicine>{
      return this.api.getById(url);
  }

  create(url: string, data:Medicine): Observable<Medicine[]> {
    return this.api.add(url,data);
  }

  update(url: string, data:Medicine): Observable<Medicine> {
    return this.api.update(url,data);
  }
  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }

  postData(url: string, data:any[]): Observable<any> {
    return this.api.addData(url,data);
  }

  gstUpdate(url: string, data:any): Observable<any> {
    return this.api.gstUpdate(url,data);
  }
}
